import { fetchByName } from "@src/services/requests/characters";
import { Character } from "@src/types/global";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

export function useSearchCharacter() {
    const [searchResults, setSearchResults] = useState<Character[] | []>([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [displayResults, setDisplayResults] = useState<
        { name: string; id: string }[] | []
    >([]);

    const queryClient = useQueryClient();

    /**
     * Transforms the array of given characters to an array of {name: string, id: string} objects
     * for display in the searchResults
     * @param {Character[]} characters - The array of Characters coming from the server to convert
     */
    function transformSearchResults(characters: Character[]) {
        const charactersArray = characters.map((character) => {
            return {
                name: character.last_name + " " + character.first_name,
                id: character.default_version.id,
            };
        });
        setDisplayResults(charactersArray);
    }
    /**
     * The function to call whenever a user types in the box
     * @param {string} value - The user input
     */
    const handleChange = async (value: string) => {
        if (value !== "") {
            setSearchLoading(true);
            const data = await queryClient.fetchQuery({
                queryKey: ["name", value],
                queryFn: () => fetchByName(value),
                staleTime: 5000,
            });
            setSearchLoading(false);
            transformSearchResults(data!.accessible_characters);
            setSearchResults(data!.accessible_characters);
        } else {
            setDisplayResults([]);
            setSearchResults([]);
        }
    };

    return {
        searchLoading,
        searchResults,
        displayResults,
        setDisplayResults,
        handleChange,
    };
}
